import { storableError } from '../../util/errors';
import { denormalisedResponseEntities } from '../../util/data';

// ================ Action types ================ //

export const FETCH_TRANSACTIONS_REQUEST = 'app/RequestedBidsPage/FETCH_TRANSACTIONS_REQUEST';
export const FETCH_TRANSACTIONS_SUCCESS = 'app/RequestedBidsPage/FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'app/RequestedBidsPage/FETCH_TRANSACTIONS_ERROR';

export const FETCH_LISTING_REQUEST = 'app/RequestedBidsPage/FETCH_LISTING_REQUEST';
export const FETCH_LISTING_SUCCESS = 'app/RequestedBidsPage/FETCH_LISTING_SUCCESS';
export const FETCH_LISTING_ERROR = 'app/RequestedBidsPage/FETCH_LISTING_ERROR';

// ================ Reducer ================ //

const initialState = {
  transactions: [],
  fetchInProgress: false,
  fetchError: null,
  listing: null,
  fetchListingInProgress: false,
  fetchListingError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_TRANSACTIONS_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_TRANSACTIONS_SUCCESS:
      return { ...state, fetchInProgress: false, transactions: payload };
    case FETCH_TRANSACTIONS_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    case FETCH_LISTING_REQUEST:
      return { ...state, fetchListingInProgress: true, fetchListingError: null };
    case FETCH_LISTING_SUCCESS:
      return { ...state, fetchListingInProgress: false, listing: payload };
    case FETCH_LISTING_ERROR:
      return { ...state, fetchListingInProgress: false, fetchListingError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchTransactionsRequest = () => ({
  type: FETCH_TRANSACTIONS_REQUEST,
});

export const fetchTransactionsSuccess = transactions => ({
  type: FETCH_TRANSACTIONS_SUCCESS,
  payload: transactions,
});

export const fetchTransactionsError = e => ({
  type: FETCH_TRANSACTIONS_ERROR,
  error: true,
  payload: e,
});

export const fetchListingRequest = () => ({
  type: FETCH_LISTING_REQUEST,
});

export const fetchListingSuccess = listing => ({
  type: FETCH_LISTING_SUCCESS,
  payload: listing,
});

export const fetchListingError = e => ({
  type: FETCH_LISTING_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

export const fetchTransactions = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchTransactionsRequest());
  return sdk.transactions
    .query({
      listingId,
      include: [
        'customer',
        'customer.profileImage',
        'provider',
        'provider.profileImage',
        'listing',
        'listing.currentStock',
        'listing.images',
        'listing.publicData',
        'listing.author.profileImage',
        'booking',
        'reviews',
        'reviews.author',
        'reviews.subject',
      ],
    })
    .then(response => {
      // Denormalise so each transaction carries its included relationships
      // (provider, provider.profileImage, ...) for display.
      dispatch(fetchTransactionsSuccess(denormalisedResponseEntities(response)));
      return response;
    })
    .catch(e => {
      console.log('\n\n e', e)
      dispatch(fetchTransactionsError(storableError(e)));
      throw e;
    });
};

export const fetchListing = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchListingRequest());
  return sdk.ownListings
    .show({ id: listingId })
    .then(res => {
      dispatch(fetchListingSuccess(res.data.data));
      return res;
    })
    .catch(e => {
      dispatch(fetchListingError(storableError(e)));
      throw e;
    });
};
